import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function GetAll(id) {
    return await createAxios().get("/City/GetAll?StateId=" + id)
}
export async function GetById(id) {
    return await createAxios().get("/City/GetById?Id=" + id)
}
export async function Add(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/City/Add", param)
}
export async function Edit(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/City/Edit", param)

}
export async function Remove(id) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/City/Remove?Id=" + id) 
}